import type { CriterionProps } from '../model/ListingCriteria/Criterion';

const listingCriteriaUtils = {
  getCriteriaByType(criteriaList: Array<CriterionProps>, criteriaType: string) {
    const foundIndex = criteriaList?.findIndex((obj: CriterionProps) => obj.type === criteriaType);
    const targetCriteria = criteriaList?.[foundIndex] || null;

    return targetCriteria;
  },
  getNegotiableDisplay(value: boolean | null): string | null {
    return value === null ? null : value ? 'negotiable' : 'non-negotiable';
  },
};
export default listingCriteriaUtils;
